import React from 'react';

export const TokenContext = React.createContext<string | undefined>(undefined);
